<template>
  <div class="flex w-full items-center gap-2">
    <!-- <p class="text-base font-semibold">{{ product.id }}</p> -->
    <span
    :class="{
      'h-2 w-2 rounded-full': true,
      'bg-[#47BE7D]': isCompleted,
      'bg-[#E9B500] animate-pulse': isSelected && !isCompleted,
      'bg-gray-400': !isCompleted && !isSelected
    }"
    ></span>
    <div class="flex flex-grow flex-row items-center justify-between">
      <div class="flex flex-col">
        <p class="text-xs font-semibold text-white">{{ product.productCode }}</p>
        <p class="text-xs font-semibold text-white">{{ product.description }}</p>
      </div>

      <VolumeChecked :total-checked="product.totalChecked" :volume="product.volume" :class="isSelected && !isCompleted && 'animate-pulse'"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VolumeChecked from '../VolumeChecked/VolumeChecked.vue';

interface Product {
  id: string | null
  productCode: string | null
  description: string | null
  volume: number
  totalChecked: number
}

interface ReceiptProductDetailsProps {
  product: Product;
  callback?: () => Promise<unknown>;
  isSelected: boolean;
}

const isCompleted = computed(() => props.product.volume === props.product.totalChecked)

const props = defineProps<ReceiptProductDetailsProps>()
</script>

<style lang="postcss" scoped>
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>